import { MyAccountTracking } from '@utils/tracking'
import { getPagecluster } from '@otto-ec/global-resources/misc'

const PAGE_CLUSTER_NAVI_SOURCE_MAPPING: Record<string, string> = {
    MYA_Dashboard: 'MyAccountOverview',
    MYA_Orders: 'MyOrder',
    MYA_Invoices: 'InvoicePage',
    MYA_Balance: 'MyBookings',
    MYA_UP: 'MyUpHome',
    MYA_UP_Points: 'MyUpPoints',
    MYA_UP_Membership: 'MyUpMembership',
    MYA_Profile: 'MyProfile',
    MYA_Profile_Data: 'MyData',
    MYA_Profile_Permissions: 'mysettings_permissions',
    MYA_Profile_Security: 'Security',
    MYA_Licenses: 'LicensesPage',
    AftersalesOrders: 'PositionDetailPage',
    Paymentinfo: 'PaymentDetailPage',
}

function determineNaviSource(): string {
    const pageCluster = getPagecluster()
    return (pageCluster && PAGE_CLUSTER_NAVI_SOURCE_MAPPING[pageCluster]) || pageCluster || ''
}

class FlyoutNavigation {


    private readonly $navigationContainer: HTMLElement | null

    constructor(document: Document) {
        this.$navigationContainer = document.querySelector('.mya_js_flyout-navigation')
    }

    registerEvents(): void {
        if (!this.$navigationContainer) {
            return
        }

        const rows = this.$navigationContainer.querySelectorAll<HTMLElement>('.mya_js_flyout-navigation-item')
        rows.forEach(row => {
            row.addEventListener('click', () => {
                const destination = row.dataset.trackDestination ?? ''
                MyAccountTracking.trackOnNextPageImpression({
                    aftersales_NaviSource: determineNaviSource(),
                    aftersales_NaviDestination: destination,
                    aftersales_NaviType: 'Flyout'
                })
            })
        })
    }
}

export default FlyoutNavigation
